import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { generateRandomId } from "../../components/common/GenerateRandomId/GenerateRandomId";
import CustomMessage from "../../components/common/Snackbar/Snackbar";
import { axiosInstance } from "../../network/apis";
import {
  DELETE_UPLOADFILE_DE_REGISTER_URL,
  GET_AGREEMENT_LATEST_DATA_URL,
  GET_AGREEMENT_UPLOADFILE_OBJECT_ID_URL,
  GET_ATTENDANCE_HISTORY_DATA_URL,
  GET_ATTENDANCE_REQUEST_DATA_URL,
  GET_ISSUED_STORE_DOWNLOAD_QR_URL,
  GET_LEAVE_HISTORY_DATA_URL,
  GET_LEAVE_REQUEST_DATA_URL,
  GET_QR_CODE_IMAGE_BY_ISSUED_STORE_URL,
  GET_REGISTER_ASSET_DOWNLOAD_QR_CODE,
  GET_REGISTER_ASSET_PURCHASE_URL,
  GET_REGISTER_ASSET_STORE_URL,
  GET_WEEKLYOFF_SUBORDINATE_DATA_URL,
  POST_AGREEMENT_UPLOAD_FILE_DATA_URL,
  POST_ATTENDANCE_APPROVE_URL,
  POST_ATTENDANCE_REJECT_URL,
  POST_DE_REGISTER_ASSET_VERIFY_DATA_URL,
  POST_DE_REGISTER_ASSET_VERIFY_OTP_URL,
  POST_EFFECTIVE_DATE_URL,
  POST_LEAVE_APPROVE_URL,
  POST_LEAVE_REJECT_URL,
  POST_REGISTER_ASSET_VERIFY_OTP_DATA_URL,
  POST_REGISTER_ASSET_VERIFY_OTP_URL,
  POST_WEEKOFF_DAY_URL,
} from "../../network/apis/apiPath";
import {
  AGREEMENT_PATH,
  ASSETS_REGISTER_VERIFY_OTP_PATH,
  DE_REGISTER_ASSET_PATH,
  DE_REGISTER_ASSET_VERIFY_OTP_PATH,
} from "../../utils/Constants";
import { getLocalStoreString } from "../../utils/Helper";
import {
  ADD_EFFECTIVEDATE_REGISTERED_ASSET,
  CLEAR_DE_REGISTER_ASSET_STATE,
  CLEAR_EFFECTIVE_DATE,
  DELETE_DE_REGISTER_ASSET_LIST,
  DELETE_FILETR_DE_REG_ASSET_DATA,
  DELETE_UPLOADFILE_DE_REGISTER,
  DE_REGISTER_ASSET_LIST,
  GET_AGREEMENT_LATEST_DATA,
  GET_AGREEMENT_UPLOADFILE_OBJECT_DATA,
  GET_ASSET_UPLOADFILE_OBJECT_DATA,
  GET_ATTENDANCE_HISTORY_DATA,
  GET_ATTENDANCE_REQUEST_DATA,
  GET_FILTERED_DE_REGISTER_ASSET_DATA,
  GET_ISSUED_STORE_DOWNLOAD_QR,
  GET_LEAVE_HISTORY_DATA,
  GET_LEAVE_REQUEST_DATA,
  GET_OR_CODE_ISSUED_STORE,
  GET_OTP_DE_REGISTER_ASSET,
  GET_REGISTER_ASSET_PURCHASE_DATA,
  GET_REGISTER_ASSET_QR_CODE,
  GET_REGISTER_ASSET_STORE_DATA,
  GET_WEEKOFF_SUBORDINATE_DATA,
  HIDE_MODAL_ASSETGROUP,
  HIDE_MODAL_SELECT_ITEM,
  HIDE_MODAL_SELECT_STORE,
  IS_CHECKED,
  IS_CHECKED_ALL_ITEMS,
  IS_CHECKED_ITEMS,
  IS_FILTER,
  IS_IOS_DEVICE,
  POST_AGREEMENT_UPLOAD_DATA,
  POST_ATTENDANCE_APPROVE_DATA,
  POST_ATTENDANCE_REJECT_DATA,
  POST_DE_REGISTER_ASSET_OTP_VERIFIED_DATA,
  POST_EFFECTIVE_DATE_DATA,
  POST_LEAVE_APPROVE_DATA,
  POST_LEAVE_REJECT_DATA,
  POST_REGISTER_ASSET_OTP_VERIFIED_DATA,
  POST_REGISTER_ASSET_VERIFY_OTP_DATA,
  POST_WEEKOFF_SUBORDINATE_DATA,
  SELECTED_ASSET_INFO_DE_REGISTER,
  SELECTED_DATA_DECREMENT,
  SELECTED_DATA_INCREMENT,
  SELECT_STORE_DATA,
  SET_PURCHASED_DATA,
  SET_SELECT_PURCHASED_DATA,
  SHOW_MODAL_ASSETGROUP,
  SHOW_MODAL_SELECT_ITEM,
  SHOW_MODAL_SELECT_STORE,
} from "../type";
import {
  checkIsIosDevice,
  clearDeRegisterState,
  deletedeRegisterAssetList,
  deleteFilteredDeRegisterAssetData,
  deRegisterAssetList,
  getOtpDeRegisterAsset,
  saveAddEffectiveDateData,
  saveAgreementDraftDataData,
  saveAgreementSelectedUploadFiles,
  saveAgreementUploadedFiles,
  saveAgreemnetUploadfileObjectId,
  saveAttendanceHistoryData,
  saveAttendanceRequestData,
  saveClearEffectiveDateData,
  saveFilteredDeRegisterAssetData,
  saveGetQRByIssuedStore,
  saveIsCheckedAllItemsDataDownloadQR,
  saveIsCheckedData,
  saveIsCheckedDataDownloadQR,
  saveIsFilterCheckedData,
  saveIssuedStoreDataDownloadQr,
  saveLeaveHistoryData,
  saveLeavesRequestData,
  saveModalAssetgroup,
  saveModalSelectItem,
  saveModalSelectStore,
  savePurchasedData,
  saveRegisterAssetData,
  saveRegisterAssetGetQRCode,
  saveRegisterAssetStoreData,
  saveSelectedAssetInfo,
  saveSelectedDecrementData,
  saveSelectedIncrementData,
  saveSetSelectData,
  saveWeekoffSubordinateData,
} from "./attendanceConfigSlice";

function* getAttendanceRequestDataWorker(action) {
  const { page1, pageSize1, EmployeeCode } = action.payload;
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_ATTENDANCE_REQUEST_DATA_URL}?pageNumber=${page1}&pageSize=${pageSize1}&approver=${EmployeeCode}`
    );
    if (response.data) {
      yield put(saveAttendanceRequestData(response.data));
    }
  } catch (error) {
    console.log(error);
  }
}

function* postAttendanceApproveDataWorker(action) {
  const {
    payload,
    enqueueSnackbar,
    setRemarkmodal,
    setSelectionModel,
    getAttendanceRequestData,
  } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      `${POST_ATTENDANCE_APPROVE_URL}`,
      payload?.requestDataEntities
    );
    if (response?.data) {
      setRemarkmodal(false);
      setSelectionModel([]);
      getAttendanceRequestData();
      CustomMessage("Approved SuccessFully", "success", enqueueSnackbar);
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* getLeaveRequestDataWorker(action) {
  const { page1, pageSize1, EmployeeCode } = action.payload;

  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_LEAVE_REQUEST_DATA_URL}?pageNumber=${page1}&pageSize=${pageSize1}&approver=${EmployeeCode}`
    );
    if (response.data) {
      yield put(saveLeavesRequestData(response.data));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* postLEaveApproveDataWorker(action) {
  const {
    payload,
    enqueueSnackbar,
    setRemarkmodal,
    setSelectionModel,
    getLEaveRequestData,
  } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      `${POST_LEAVE_APPROVE_URL}`,
      payload?.requestDataEntities
    );
    if (response?.data) {
      setRemarkmodal(false);
      setSelectionModel([]);
      getLEaveRequestData();
      CustomMessage("Approved SuccessFully", "success", enqueueSnackbar);
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* getAttendanceHistoryDataWorker(action) {
  const { approver, endDate, pageNumber, pageSize, startDate, status } =
    action?.payload;
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_ATTENDANCE_HISTORY_DATA_URL}?pageNumber=${pageNumber}&pageSize=${pageSize}&approver=${approver}&status=${status}&startDate=${startDate}&endDate=${endDate}`
    );
    if (response.data) {
      yield put(saveAttendanceHistoryData(response.data));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* postAttendanceRejectDataWorker(action) {
  const {
    payload,
    enqueueSnackbar,
    setRemarkmodal,
    setSelectionModel,
    getAttendanceRequestData,
  } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      `${POST_ATTENDANCE_REJECT_URL}`,
      payload?.requestDataEntities
    );
    if (response?.data) {
      setRemarkmodal(false);
      setSelectionModel([]);
      getAttendanceRequestData();
      CustomMessage("Rejected SuccessFully", "success", enqueueSnackbar);
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* postLeaveRejectDataWorker(action) {
  const {
    payload,
    enqueueSnackbar,
    setRemarkmodal,
    setSelectionModel,
    getLEaveRequestData,
  } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      `${POST_LEAVE_REJECT_URL}`,
      payload?.requestDataEntities
    );
    if (response?.data) {
      setRemarkmodal(false);
      setSelectionModel([]);
      getLEaveRequestData();
      CustomMessage("Rejected SuccessFully", "success", enqueueSnackbar);
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* getLeaveHistoryDataWorker(action) {
  const { approver, endDate, pageNumber, pageSize, startDate, status } =
    action?.payload;
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_LEAVE_HISTORY_DATA_URL}?pageNumber=${pageNumber}&pageSize=${pageSize}&approver=${approver}&status=${status}&startDate=${startDate}&endDate=${endDate}`
    );
    if (response.data) {
      yield put(saveLeaveHistoryData(response.data));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* getWeekOffSubordinateDataWorker(action) {
  const { EmployeeCode } = action.payload;
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_WEEKLYOFF_SUBORDINATE_DATA_URL}?managerCode=${EmployeeCode}`
    );
    if (response.data) {
      yield put(saveWeekoffSubordinateData(response.data));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* postWeekOffSubordinateDataWorker(action) {
  const { payload, enqueueSnackbar, getSubordinateData, setExpanded } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      `${POST_WEEKOFF_DAY_URL}`,
      payload
    );
    if (response?.data) {
      setExpanded(false);
      getSubordinateData();
      CustomMessage("Week Off added successfully", "success", enqueueSnackbar);
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* getRegisterAssetDataWorker(action) {
  try {
    const response = yield call(
      axiosInstance.get,
      GET_REGISTER_ASSET_PURCHASE_URL
    );
    if (response.data) {
      const selectData = response?.data?.map((item) => ({
        ...item,
        count: 0,
        checked: false,
      }));
      yield put(saveRegisterAssetData(selectData));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* getRegisterAssetStoreDataWorker(action) {
  const { EmployeeCode } = action;
  const BearerToken = localStorage.getItem("BearerToken");
  const TenantId = localStorage.getItem("CompanyID");
  try {
    const response = yield call(
      axios.get,
      `${GET_REGISTER_ASSET_STORE_URL}?employeeCode=${EmployeeCode}`,
      {
        headers: {
          Authorization: `Bearer ${BearerToken}`,
          "Tenant-Id": TenantId,
        },
      }
    );
    if (response.data) {
      yield put(saveRegisterAssetStoreData(response.data));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* postRegisterAssetVerifyOtpWorker(action) {
  const { payload, enqueueSnackbar, navigate, selectedItemsPurchaseId } =
    action;
  const { storeData } = payload;
  const storeCode = { storeCode: storeData[0]?.code };
  try {
    const response = yield call(
      axiosInstance.post,
      POST_REGISTER_ASSET_VERIFY_OTP_URL,
      storeCode
    );
    if (response?.status == 200) {
      CustomMessage("OTP sent", "success", enqueueSnackbar);
      navigate(ASSETS_REGISTER_VERIFY_OTP_PATH, {
        state: {
          mobileNumber: response?.data?.mobileNumber,
          personName: response?.data?.personName,
          storeCode: storeCode,
          purchaseId: selectedItemsPurchaseId,
          status: response?.status,
        },
      });
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* postRegisterAssetOtpVerifiedWorker(action) {
  const { payload, enqueueSnackbar, setOtpError, setOpen } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      POST_REGISTER_ASSET_VERIFY_OTP_DATA_URL,
      payload
    );
    if (response?.status == 200) {
      setOpen(true);
      setOtpError(false);
    }
  } catch (error) {
    setOtpError(true);
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* getRegisterAssetQRCode(action) {
  const { assetCode, navigate } = action;
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_REGISTER_ASSET_DOWNLOAD_QR_CODE}?assetCode=${assetCode}&width=20&height=20`
    );
    if (response.data) {
      yield put(saveRegisterAssetGetQRCode(response.data));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* setSelectedDataIncrement(action) {
  yield put(saveSelectedIncrementData(action.payload));
}

function* setSelectedDataDecrement(action) {
  yield put(saveSelectedDecrementData(action?.payload));
}
function* setSelectedDataChecked(action) {
  yield put(saveIsCheckedData(action.payload));
}

function* setSelectedDataCheckedDownloadQR(action) {
  yield put(saveIsCheckedDataDownloadQR(action.payload));
}
function* setCheckedAllItemsDownloadQR(action) {
  yield put(saveIsCheckedAllItemsDataDownloadQR(action.payload));
}

function* setSelectedDataFilterChecked(action) {
  yield put(saveIsFilterCheckedData(action.payload));
}
//.......modal....
function* showModalAssetGroup() {
  yield put(saveModalAssetgroup({ type: SHOW_MODAL_ASSETGROUP }));
}
function* hideModalAssetGroup() {
  yield put(saveModalAssetgroup({ type: HIDE_MODAL_ASSETGROUP }));
}

function* showModalSelectItem() {
  yield put(saveModalSelectItem({ type: SHOW_MODAL_SELECT_ITEM }));
}

function* hideModalSelectItem() {
  yield put(saveModalSelectItem({ type: HIDE_MODAL_SELECT_ITEM }));
}

function* showModalSelectStore() {
  yield put(saveModalSelectStore({ type: SHOW_MODAL_SELECT_STORE }));
}

function* hideModalSelectStore() {
  yield put(saveModalSelectStore({ type: HIDE_MODAL_SELECT_STORE }));
}

function* getAgreementLatest(action) {
  const { payload } = action;
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_AGREEMENT_LATEST_DATA_URL}?storeCode=${payload}`
    );
    if (response.data) {
      yield put(saveAgreementDraftDataData(response?.data));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* getAgreementUploadfileObjectIdWorker(action) {
  const BearerToken = localStorage.getItem("BearerToken");
  const TenantId = getLocalStoreString("CompanyID");
  const {
    payload,
    setObjId,
    setLoader,
    enqueueSnackbar,
    setUploadPhotos,
    setDisableUploadbutton,
    setDisableSubmitbutton,
  } = action;
  const { uploadFile, employeeCode } = payload;
  const endnameFormate = uploadFile?.name?.split(".")[1];
  const formData = new FormData();
  formData.append("file", uploadFile);
  console.log("formData", formData);
  try {
    const response = yield call(
      axios.post,
      `${GET_AGREEMENT_UPLOADFILE_OBJECT_ID_URL}?employeeCode=${employeeCode}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${BearerToken}`,
          "Tenant-Id": TenantId,
        },
      }
    );
    if (response) {
      setObjId(response?.data);
      setUploadPhotos((prev) => [...prev, response?.data]);
      const { id } = response?.data;
      const objectId = "objectId";
      const fileName = "fileName";
      const updatedObject = {
        [objectId]: id,
        [fileName]: `attachment${generateRandomId(2)}.${endnameFormate}`,
      };
      const addRandomId = { ...updatedObject, randomId: uploadFile.randomId };
      yield put(saveAgreemnetUploadfileObjectId(addRandomId));
      yield put(saveAgreementSelectedUploadFiles(uploadFile));
      setDisableUploadbutton(false);
      setDisableSubmitbutton(true);
      setLoader(false);
    }
  } catch (error) {
    setLoader(false);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}
function* getAssetUploadfileObjectIdWorker(action) {
  const BearerToken = localStorage.getItem("BearerToken");
  const TenantId = getLocalStoreString("CompanyID");
  const { payload, setObjId, setLoader, enqueueSnackbar, setUploadPhotos } =
    action;
  const { uploadFile, employeeCode } = payload;
  const endnameFormate = uploadFile?.name?.split(".")[1];
  const formData = new FormData();
  formData.append("file", uploadFile);
  console.log("formData", formData);
  try {
    const response = yield call(
      axios.post,
      `${GET_AGREEMENT_UPLOADFILE_OBJECT_ID_URL}?employeeCode=${employeeCode}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${BearerToken}`,
          "Tenant-Id": TenantId,
        },
      }
    );
    if (response) {
      setLoader(false);
      setObjId(response?.data);
      setUploadPhotos((prev) => [...prev, response?.data]);
      const { id } = response?.data;
      const objectId = "objectId";
      const fileName = "fileName";
      const updatedObject = {
        [objectId]: id,
        [fileName]: `attachment${generateRandomId(2)}.${endnameFormate}`,
      };
      const addRandomId = { ...updatedObject, randomId: uploadFile.randomId };
      yield put(saveAgreemnetUploadfileObjectId(addRandomId));
      yield put(saveAgreementSelectedUploadFiles(uploadFile));
    }
  } catch (error) {
    setLoader(false);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* postAgreementUploadData(action) {
  const { payload, setIsAgreementUploaded, setStatusRes, enqueueSnackbar } =
    action;
  try {
    const response = yield call(
      axiosInstance.post,
      POST_AGREEMENT_UPLOAD_FILE_DATA_URL,
      payload
    );
    if (response?.status == 200) {
      yield put(saveAgreementUploadedFiles(response?.data));
      setStatusRes(response?.status);
      setIsAgreementUploaded(true);
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* getIssuedStoreDownloadQR(action) {
  const { storeCode } = action.payload;

  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_ISSUED_STORE_DOWNLOAD_QR_URL}?storeCode=${storeCode}&pageNumber=0&pageSize=100`
    );
    if (response?.data?.entities) {
      const selectData = response?.data?.entities?.map((item) => ({
        ...item,
        checkedAll: false,
        checked: false,
        isSelected: false,
        AddEffectiveDate: "",
      }));
      yield put(saveIssuedStoreDataDownloadQr(selectData));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* getQRCodeByIssuedStore(action) {
  const { payload, handleCheck, enqueueSnackbar } = action;
  const { storeCode, assetCode } = payload;

  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_QR_CODE_IMAGE_BY_ISSUED_STORE_URL}?assetCode=${assetCode}&storeCode=${storeCode}&width=350&height=350`
    );
    if (response?.data) {
      yield put(saveGetQRByIssuedStore(response?.data));
    }
    if (response?.status == 200) {
      handleCheck(response?.data);
    }
  } catch (error) {
    console.log("error", error.response.data.message);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* setSelectStoreData(action) {
  yield put(saveSetSelectData(action.payload));
}

function* gsetSelectedDeRegisterAssetInfo(action) {
  yield put(saveSelectedAssetInfo(action.payload));
}

function* deleteUploadFileDeRegister(action) {
  const { employeeCode, objectId } = action.payload;
  try {
    const response = yield call(
      axiosInstance.delete,
      `${DELETE_UPLOADFILE_DE_REGISTER_URL}?objectId=${objectId}&employeeCode=${employeeCode}`
    );
    if (response?.data) {
      console.log("response?.data", response?.data);
    }
  } catch (error) {
    console.log("error", error.response.data.message);
  }
}

function* deRegisterAssetListData(action) {
  const { navigate } = action;
  if (action?.payload) {
    yield put(deRegisterAssetList(action?.payload));
    navigate(DE_REGISTER_ASSET_PATH);
  }
}

function* emptyDeRegisterState() {
  yield put(clearDeRegisterState());
}

function* deletedeRegisterAssetListData(action) {
  yield put(deletedeRegisterAssetList(action?.payload));
}

function* postDeRegisterAssetVerifyOtp(action) {
  const { payload, enqueueSnackbar, navigate } = action;
  const { storeData } = payload;
  const storeCode = { storeCode: storeData[0]?.code };
  try {
    const response = yield call(
      axiosInstance.post,
      POST_DE_REGISTER_ASSET_VERIFY_OTP_URL,
      storeCode
    );
    if (response?.status == 200) {
      CustomMessage("OTP sent", "success", enqueueSnackbar);
      navigate(DE_REGISTER_ASSET_VERIFY_OTP_PATH, {
        state: {
          mobileNumber: response?.data?.mobileNumber,
          personName: response?.data?.personName,
          status: response?.status,
        },
      });
      yield put(getOtpDeRegisterAsset(response));
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* postDeRegisterAssetVerifyData(action) {
  const { payload, enqueueSnackbar, setOtpError, setOpen } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      POST_DE_REGISTER_ASSET_VERIFY_DATA_URL,
      payload
    );
    if (response?.status == 200) {
      setOpen(true);
      setOtpError(false);
    }
  } catch (error) {
    setOtpError(true);
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* getFilterDeRegisterAssetData(action) {
  yield put(saveFilteredDeRegisterAssetData(action?.payload));
}
function* deleteFilterDeRegisterAssetData(action) {
  yield put(deleteFilteredDeRegisterAssetData(action?.payload));
}

function* checkIsiOSDevice(action) {
  yield put(checkIsIosDevice(action.payload));
}

function* postEffectiveDateRegisteredAssetAgreement(action) {
  const { payload, navigate, storeCode } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      POST_EFFECTIVE_DATE_URL,
      payload
    );
    if (response?.status == 200) {
      try {
        const response = yield call(
          axiosInstance.get,
          `${GET_AGREEMENT_LATEST_DATA_URL}?storeCode=${storeCode}`
        );
        if (response.data) {
          yield put(saveAgreementDraftDataData(response?.data));
          navigate(AGREEMENT_PATH);
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  } catch (error) {
    console.log(error);
  }
}

function* AddEffectiveDateToRegisteredAssetDate(action) {
  yield put(saveAddEffectiveDateData(action.payload));
}

function* clearEffectiveDate(action) {
  yield put(saveClearEffectiveDateData(action.payload));
}

function* setPurchasedData(action) {
  yield put(savePurchasedData(action.payload));
}

export function* attendanceConfigWatcher() {
  yield takeLatest(GET_ATTENDANCE_REQUEST_DATA, getAttendanceRequestDataWorker);
  yield takeLatest(
    POST_ATTENDANCE_APPROVE_DATA,
    postAttendanceApproveDataWorker
  );
  yield takeLatest(GET_LEAVE_REQUEST_DATA, getLeaveRequestDataWorker);
  yield takeLatest(POST_LEAVE_APPROVE_DATA, postLEaveApproveDataWorker);
  yield takeLatest(GET_ATTENDANCE_HISTORY_DATA, getAttendanceHistoryDataWorker);
  yield takeLatest(POST_ATTENDANCE_REJECT_DATA, postAttendanceRejectDataWorker);
  yield takeLatest(POST_LEAVE_REJECT_DATA, postLeaveRejectDataWorker);
  yield takeLatest(GET_LEAVE_HISTORY_DATA, getLeaveHistoryDataWorker);
  yield takeLatest(
    GET_WEEKOFF_SUBORDINATE_DATA,
    getWeekOffSubordinateDataWorker
  );
  yield takeLatest(
    POST_WEEKOFF_SUBORDINATE_DATA,
    postWeekOffSubordinateDataWorker
  );
  yield takeLatest(
    GET_REGISTER_ASSET_PURCHASE_DATA,
    getRegisterAssetDataWorker
  );
  yield takeLatest(
    GET_REGISTER_ASSET_STORE_DATA,
    getRegisterAssetStoreDataWorker
  );
  yield takeLatest(
    POST_REGISTER_ASSET_VERIFY_OTP_DATA,
    postRegisterAssetVerifyOtpWorker
  );
  yield takeLatest(
    POST_REGISTER_ASSET_OTP_VERIFIED_DATA,
    postRegisterAssetOtpVerifiedWorker
  );
  yield takeLatest(GET_REGISTER_ASSET_QR_CODE, getRegisterAssetQRCode);
  yield takeLatest(SELECTED_DATA_INCREMENT, setSelectedDataIncrement);
  yield takeLatest(SELECTED_DATA_DECREMENT, setSelectedDataDecrement);
  yield takeLatest(GET_AGREEMENT_LATEST_DATA, getAgreementLatest);
  yield takeLatest(IS_CHECKED, setSelectedDataChecked);
  yield takeLatest(IS_FILTER, setSelectedDataFilterChecked);
  yield takeLatest(IS_CHECKED_ITEMS, setSelectedDataCheckedDownloadQR);
  yield takeLatest(POST_AGREEMENT_UPLOAD_DATA, postAgreementUploadData);
  yield takeLatest(
    GET_AGREEMENT_UPLOADFILE_OBJECT_DATA,
    getAgreementUploadfileObjectIdWorker
  );
  yield takeLatest(
    GET_ASSET_UPLOADFILE_OBJECT_DATA,
    getAssetUploadfileObjectIdWorker
  );
  yield takeLatest(GET_ISSUED_STORE_DOWNLOAD_QR, getIssuedStoreDownloadQR);
  yield takeLatest(GET_OR_CODE_ISSUED_STORE, getQRCodeByIssuedStore);
  yield takeLatest(IS_CHECKED_ALL_ITEMS, setCheckedAllItemsDownloadQR);
  yield takeLatest(SHOW_MODAL_ASSETGROUP, showModalAssetGroup);
  yield takeLatest(SHOW_MODAL_SELECT_ITEM, showModalSelectItem);
  yield takeLatest(HIDE_MODAL_ASSETGROUP, hideModalAssetGroup);
  yield takeLatest(HIDE_MODAL_SELECT_ITEM, hideModalSelectItem);
  yield takeLatest(SELECT_STORE_DATA, setSelectStoreData);
  yield takeLatest(HIDE_MODAL_SELECT_STORE, hideModalSelectStore);
  yield takeLatest(SHOW_MODAL_SELECT_STORE, showModalSelectStore);
  yield takeLatest(
    SELECTED_ASSET_INFO_DE_REGISTER,
    gsetSelectedDeRegisterAssetInfo
  );
  yield takeLatest(DELETE_UPLOADFILE_DE_REGISTER, deleteUploadFileDeRegister);
  yield takeLatest(DE_REGISTER_ASSET_LIST, deRegisterAssetListData);
  yield takeLatest(
    DELETE_DE_REGISTER_ASSET_LIST,
    deletedeRegisterAssetListData
  );
  yield takeLatest(GET_OTP_DE_REGISTER_ASSET, postDeRegisterAssetVerifyOtp);
  yield takeLatest(
    POST_DE_REGISTER_ASSET_OTP_VERIFIED_DATA,
    postDeRegisterAssetVerifyData
  );
  yield takeLatest(
    GET_FILTERED_DE_REGISTER_ASSET_DATA,
    getFilterDeRegisterAssetData
  );
  yield takeLatest(CLEAR_DE_REGISTER_ASSET_STATE, emptyDeRegisterState);
  yield takeLatest(
    DELETE_FILETR_DE_REG_ASSET_DATA,
    deleteFilterDeRegisterAssetData
  );
  yield takeLatest(IS_IOS_DEVICE, checkIsiOSDevice);
  yield takeLatest(
    POST_EFFECTIVE_DATE_DATA,
    postEffectiveDateRegisteredAssetAgreement
  );
  yield takeLatest(
    ADD_EFFECTIVEDATE_REGISTERED_ASSET,
    AddEffectiveDateToRegisteredAssetDate
  );
  yield takeLatest(CLEAR_EFFECTIVE_DATE, clearEffectiveDate);
  yield takeLatest(SET_PURCHASED_DATA, setPurchasedData);
}
